import activityRepository from './activityRepository';
import authRepository from './authRepository';
import userRepository from './userRepository';


const repositories = {
  activities: activityRepository,
  auth: authRepository,
  users: userRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name]
};